import * as vp from 'vopay';
import { FunctionComponent, useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import EditGroupForm from './EditGroupForm';
import usePostEditGroup from '@/hooks/useApi/usePostEditGroup';
import { EditGroupDialogueHandler, DialogueHandlerProps } from '../Dialogue/types';
import EditGroupDialogueContext, { EditGroupCtx } from '../Dialogue/EditGroup/EditGroupContext';
import GroupGreationDialogue from '../Dialogue/EditGroup/EditGroupDialogue';
import useFetchContactGroups from '@/hooks/useApi/useFetchContactGroups';
import { useUserSettingsProvider } from '@/providers/UserSettings.provider';
import { useTranslation } from 'react-i18next';

const { Box, Title } = vp;

type ValuePair = {
  GroupName: string;
  Description: string;
};

type FC = FunctionComponent;

const EditGroupContainer: FC = () => {
  const history = useHistory();
  const { userSettings } = useUserSettingsProvider();
  const [editGroupResponse, postEditGroup] = usePostEditGroup({});
  const [shouldEditGroup, setShouldEditGroup] = useState(false);
  const [showEditGroupErrorAlert, setShowEditGroupErrorAlert] = useState(false);
  const [editGroupError, setEditGroupError] = useState('');
  const [ContactGroups, fetchContactGroups] = useFetchContactGroups({});
  const { t } = useTranslation('translations', { keyPrefix: 'Groups.Edit' });

  const { GroupID } = useParams<{ GroupID: string }>();
  const [group, setgroup] = useState<vp.ContactGroupsLists>({
    ACTCurrencies_ID: '',
    DateAdded: '',
    Description: '',
    GroupName: '',
    ID: '',
    LastModified: '',
    Service: '',
    VIOAccounts_ID: '',
  });
  const EditGroup: EditGroupCtx = {
    showEditGroupErrorAlert,
    editGroupError,
  };
  useEffect(() => {
    fetchContactGroups({
      Timezone: userSettings.timezone,
    });
  }, []);
  useEffect(() => {
    const groupSet = Object.values(ContactGroups.ContactGroups).find((contactGroup) => contactGroup.ID === GroupID);
    if (groupSet) {
      setgroup(groupSet);
    }
  }, [ContactGroups]);
  const handlers = {
    handleEditGroupDialogue: (handlerProps: DialogueHandlerProps<EditGroupDialogueHandler>) => {
      const { type, state, action = 'default' } = handlerProps;
      const dialogueHandlers: EditGroupDialogueHandler = {
        error: {
          confirm: {
            default: () => {
              setShowEditGroupErrorAlert(false);
            },
          },
        },
      };
      const dialogueState = dialogueHandlers[type][state];
      const handler = dialogueState[action] || dialogueState.default;
      handler();
    },
    onEditGroup: (_values: ValuePair) => {
      setShouldEditGroup(true);
      postEditGroup({
        GroupName: _values.GroupName,
        Description: _values.Description,
        GroupID: group.ID,
      });
    },
  };

  useEffect(() => {
    if (shouldEditGroup) {
      const { Success, ErrorMessage } = editGroupResponse;

      if (Success === true) {
        history.goBack();
      } else if (Success === false) {
        setShowEditGroupErrorAlert(true);
        setEditGroupError(ErrorMessage);
      }
      setShouldEditGroup(false);
    }
  }, [editGroupResponse]);

  return (
    <EditGroupDialogueContext.Provider value={EditGroup}>
      <Box mb="md" flx="col" gap="lg">
        <Box mb="md" jc="sb">
          <Title title={t('pageTitle')} />
        </Box>
        <EditGroupForm group={group} handlers={handlers} />
      </Box>
      <GroupGreationDialogue handleDialogue={handlers.handleEditGroupDialogue} />
    </EditGroupDialogueContext.Provider>
  );
};

export default EditGroupContainer;
